import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Layout from "./components/layout/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";

import Categories from "./pages/categories/Categories";
import CreateCategory from "./pages/categories/CreateCategory";
import EditCategory from "./pages/categories/EditCategory";

import Brands from "./pages/brands/Brands";
import CreateBrand from "./pages/brands/CreateBrand";
import EditBrand from "./pages/brands/EditBrand";

import Presentations from "./pages/presentations/Presentations";
import CreatePresentation from "./pages/presentations/CreatePresentation";
import EditPresentation from "./pages/presentations/EditPresentation";

import Products from "./pages/products/Products";
import CreateProduct from "./pages/products/CreateProduct";
import EditProduct from "./pages/products/EditProduct";

import Users from "./pages/users/Users";
import CreateUser from "./pages/users/CreateUser";
import EditUser from "./pages/users/EditUser";

import Suppliers from "./pages/suppliers/Suppliers";
import CreateSupplier from "./pages/suppliers/CreateSupplier";
import EditSupplier from "./pages/suppliers/EditSupplier";

import Clients from "./pages/departments/Clients";
import CreateClient from "./pages/departments/CreateClient";
import EditClient from "./pages/departments/EditClient";

import RegisterEntry from "./pages/entries/RegisterEntry";
import Entries from "./pages/entries/Entries";
import EntryDetails from "./pages/entries/EntryDetails";
import PurchaseOrders from "./pages/purchaseOrders/PurchaseOrders";
import CreatePurchaseOrder from "./pages/purchaseOrders/CreatePurchaseOrder";
import EditPurchaseOrder from "./pages/purchaseOrders/EditPurchaseOrder";
import PurchaseOrderDetails from "./pages/purchaseOrders/PurchaseOrderDetails";
import ReceivePurchaseOrder from "./pages/purchaseOrders/ReceivePurchaseOrder";

import RegisterExit from "./pages/exits/RegisterExit";
import Exits from "./pages/exits/Exits";
import ExitDetails from "./pages/exits/ExitDetails";

import ActiveCategories from "./pages/actives/actives/categories/ActiveCategories";
import CreateActiveCategory from "./pages/actives/actives/categories/CreateActiveCategory";
import EditActiveCategory from "./pages/actives/actives/categories/EditActiveCategory";

import ActiveLocations from "./pages/actives/actives/locations/ActiveLocations";
import CreateActiveLocation from "./pages/actives/actives/locations/CreateActiveLocation";
import EditActiveLocation from "./pages/actives/actives/locations/EditActiveLocation";

import Actives from "./pages/actives/actives/Actives";
import CreateActive from "./pages/actives/actives/CreateActive";
import EditActive from "./pages/actives/actives/EditActive";
import ActivesDashboard from "./pages/actives/actives/ActivesDashboard";

import Invoices from "./pages/invoices/Invoices";
import CreateInvoice from "./pages/invoices/CreateInvoice";
import EditInvoice from "./pages/invoices/EditInvoice";
import InvoicesDashboard from "./pages/invoices/InvoicesDashboard";
import InvoicePayments from "./pages/invoices/InvoicePayments";

import Requests from "./pages/requests/Requests";
import CreateRequest from "./pages/requests/CreateRequest";
import RequestDetails from "./pages/requests/RequestDetails";
import RequestDelivery from "./pages/requests/RequestDelivery";

import Inventory from "./pages/inventories/Inventory";
import InventoryExit from "./pages/inventories/InventoriesExit";
import InventoryInitialLoad from "./pages/inventories/InventoryInitialLoad";

import Kardex from "./pages/kardex/Kardex";

import RutaPrivada from "./routes/RutaPrivada";

function App() {
  return (
    <BrowserRouter>
      <ToastContainer position="top-right" autoClose={3000} />

      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />

        <Route element={<Layout />}>

          {/* 1. DASHBOARD GENERAL */}
          <Route
            element={<RutaPrivada allowedRoles={["Administrador", "Dashboards", "Insumos"]} />}
          >
            <Route path="/dashboard" element={<Dashboard />} />
          </Route>

          {/* ADMINISTRADOR - Usuarios */}
          <Route element={<RutaPrivada allowedRoles={["Administrador"]} />}>
            <Route path="/users" element={<Users />} />
            <Route path="/users/create" element={<CreateUser />} />
            <Route path="/users/edit/:id" element={<EditUser />} />
          </Route>

          {/* 🚀 PROVEEDORES - Compartido entre Insumos, Facturación y Administrador */}
          <Route
            element={<RutaPrivada allowedRoles={["Insumos", "Facturacion", "Administrador"]} />}
          >
            <Route path="/suppliers" element={<Suppliers />} />
            <Route path="/suppliers/create" element={<CreateSupplier />} />
            <Route path="/suppliers/edit/:id" element={<EditSupplier />} />
          </Route>

          {/* GESTIÓN DE INVENTARIO - Solo Insumos y Administrador */}
          <Route
            element={<RutaPrivada allowedRoles={["Insumos", "Administrador"]} />}
          >
            <Route path="/categories" element={<Categories />} />
            <Route path="/categories/create" element={<CreateCategory />} />
            <Route path="/categories/edit/:id" element={<EditCategory />} />

            <Route path="/brands" element={<Brands />} />
            <Route path="/brands/create" element={<CreateBrand />} />
            <Route path="/brands/edit/:id" element={<EditBrand />} />

            <Route path="/presentations" element={<Presentations />} />
            <Route path="/presentations/create" element={<CreatePresentation />} />
            <Route path="/presentations/edit/:id" element={<EditPresentation />} />

            <Route path="/products" element={<Products />} />
            <Route path="/products/create" element={<CreateProduct />} />
            <Route path="/products/edit/:id" element={<EditProduct />} />

            <Route path="/clients" element={<Clients />} />
            <Route path="/clients/create" element={<CreateClient />} />
            <Route path="/clients/edit/:id" element={<EditClient />} />

            <Route path="/entries" element={<Entries />} />
            <Route path="/entries/create" element={<RegisterEntry />} />
            <Route path="/entries/:id" element={<EntryDetails />} />

            <Route path="/purchase-orders" element={<PurchaseOrders />} />
            <Route path="/purchase-orders/create" element={<CreatePurchaseOrder />} />
            <Route path="/purchase-orders/:id/edit" element={<EditPurchaseOrder />} />
            <Route path="/purchase-orders/:id" element={<PurchaseOrderDetails />} />
            <Route path="/purchase-orders/:id/receive" element={<ReceivePurchaseOrder />} />

            <Route path="/exits" element={<Exits />} />
            <Route path="/exits/create" element={<RegisterExit />} />
            <Route path="/exits/:id" element={<ExitDetails />} />

            <Route path="/kardex" element={<Kardex />} />
          </Route>

          {/* FACTURACIÓN */}
          <Route element={<RutaPrivada allowedRoles={["Facturacion", "Administrador", "Dashboards"]} />}>
            <Route path="/invoices/dashboard" element={<InvoicesDashboard />} />
            <Route element={<RutaPrivada allowedRoles={["Facturacion", "Administrador"]} />}>
              <Route path="/invoices" element={<Invoices />} />
              <Route path="/invoices/create" element={<CreateInvoice />} />
              <Route path="/invoices/edit/:id" element={<EditInvoice />} />
              <Route path="/invoices/:id/payments" element={<InvoicePayments />} />
            </Route>
          </Route>

          {/* ACTIVOS */}
          <Route element={<RutaPrivada allowedRoles={["Activos", "Administrador", "Dashboards"]} />}>
            <Route path="/actives/dashboard" element={<ActivesDashboard />} />
          </Route>
          <Route element={<RutaPrivada allowedRoles={["Activos", "Administrador", "Admin-Odontologia"]} />}>
            <Route path="/actives" element={<Actives />} />
            <Route path="/actives/create" element={<CreateActive />} />
            <Route path="/actives/edit/:id" element={<EditActive />} />
            <Route element={<RutaPrivada allowedRoles={["Activos", "Administrador"]} />}>
              <Route path="/actives/categories" element={<ActiveCategories />} />
              <Route path="/actives/categories/create" element={<CreateActiveCategory />} />
              <Route path="/actives/categories/edit/:id" element={<EditActiveCategory />} />
              <Route path="/actives/locations" element={<ActiveLocations />} />
              <Route path="/actives/locations/create" element={<CreateActiveLocation />} />
              <Route path="/actives/locations/edit/:id" element={<EditActiveLocation />} />
            </Route>
          </Route>

          <Route
            element={<RutaPrivada allowedRoles={["Solicitudes", "Administrador", "Insumos",]} />}
          >
            {/* Mi bodega */}
            <Route path="/my-inventory" element={<Inventory />} />
            <Route path="/my-inventory/exit" element={<InventoryExit />} />
            <Route path="/my-inventory/initial-load" element={<InventoryInitialLoad />} />

            {/* Solicitudes */}
            <Route path="/requests" element={<Requests />} />
            <Route path="/requests/create" element={<CreateRequest />} />
            <Route path="/requests/:id/edit" element={<CreateRequest />} />
            <Route path="/requests/:id" element={<RequestDetails />} />
            <Route path="/requests/:id/delivery" element={<RequestDelivery />} />
          </Route>

        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;